export const SmartHome = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='M16 19.5h2'></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M19 22h-4a2 2 0 01-2-2v-7a2 2 0 012-2h4a2 2 0 012 2v7a2 2 0 01-2 2z'
          clipRule='evenodd'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M9 21H4.714A1.715 1.715 0 013 19.286V15M3 4.355V9a1 1 0 001 1h5.053a1 1 0 001-1V4.355'
        ></path>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M2 5l4.592-3L11 5M16 3h3.286C20.232 3 21 3.768 21 4.714V8'
        ></path>
      </svg>
    </span>
  );
};
